import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const BOOKING_URL =
  "https://cal.com/foresight-alhassan/pre-investment-session?layout=mobile";
export const WHATSAPP_URL = "https://wa.me/16144199138";
export const WHATSAPP_DISPLAY = "+1 (614) 419-9138";

export const NEED_OPTIONS = [
  "Investment Investigation",
  "Real Estate & Property Due Diligence",
  "Ghana Settlement Services / Citizenship",
  "Private Investigation",
  "Business Intelligence",
  "Security & Risk",
  "Other",
];

export const CHECKLIST_PDF_URL = `${API}/checklist.pdf`;

export async function submitContact(payload) {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
}

export async function submitLeadMagnet(payload) {
  const { data } = await axios.post(`${API}/lead-magnet`, payload);
  return data;
}

export async function adminLogin(password) {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  return data;
}

export async function adminGetContacts(token) {
  const { data } = await axios.get(`${API}/contacts`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
}

export async function adminGetLeads(token) {
  const { data } = await axios.get(`${API}/leads`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
}

export async function adminUpdateStatus(token, collection, id, status) {
  const { data } = await axios.patch(
    `${API}/admin/status/${collection}/${id}`,
    { status },
    { headers: { "X-Admin-Token": token } }
  );
  return data;
}
